export {default as voronoi} from "./src/voronoi";



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-voronoi/index.js
// module id = ../../../../d3-voronoi/index.js
// module chunks = vendor